import { useCallback } from 'react';

import { useDocumentTypeAssociationsQuery } from './queries';

type DocumentTypeOption = {
  label: string;
  value: number;
};

// Options for 'Select Document Type' dropdown
const useDocumentTypeOptions = (
  selectedDocumentCategory: { value: string } | undefined,
) => {
  const { data: options } = useDocumentTypeAssociationsQuery({
    select: useCallback(
      (data) => {
        return data.reduce((acc, curr) => {
          if (curr.documentCategory === selectedDocumentCategory?.value) {
            acc.push({
              label: curr.documentClassification,
              value: curr.documentTypeId,
            });
          }
          return acc;
        }, [] as DocumentTypeOption[]);
      },
      [selectedDocumentCategory?.value],
    ),
  });

  return options ?? [];
};

export default useDocumentTypeOptions;
